import React from 'react';

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, totalSteps }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-end mb-2">
        <span className="text-[24px] font-medium text-[#121212]">
          Step {currentStep} of {totalSteps}
        </span>
       
      </div>

      {/* Segmented Progress Bar with gaps */}
      <div className="flex items-center gap-4">
        {Array.from({ length: totalSteps }).map((_, index) => {
          const isActive = index + 1 <= currentStep;
          return (
            <div
              key={index}
              className={`h-2 flex-1 rounded-full transition-all duration-500 ${
                isActive 
                  ? 'bg-gradient-to-r from-[#6661FF] via-[#00A86B] to-green-600' 
                  : 'bg-gray-200'
              }`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;